// extracted by mini-css-extract-plugin
module.exports = {"container":"pa","overlay":"qa","headingSection":"ra","close":"sa","copy":"ta","m-heart-activate":"ua","bottomSection":"va","disabled":"wa","m-heart-pulse":"xa"};